'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _effects = require('redux-saga/effects');

var _common = require('./common');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (SubmissionError) {
  return _regenerator2.default.mark(function formSubmitSaga() {
    var _ref, _ref$meta, successActionType, failureActionType, resolve, reject, payload, response, _response, _response2, _response2$, success, failure;

    return _regenerator2.default.wrap(function formSubmitSaga$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!true) {
              _context.next = 34;
              break;
            }

            _context.next = 3;
            return (0, _effects.take)(_common.FORM_SUBMIT);

          case 3:
            _ref = _context.sent;
            _ref$meta = _ref.meta;
            successActionType = _ref$meta.successActionType;
            failureActionType = _ref$meta.failureActionType;
            resolve = _ref$meta.resolve;
            reject = _ref$meta.reject;
            payload = _ref.payload;
            response = void 0;

            if (!_effects.all) {
              _context.next = 17;
              break;
            }

            _context.next = 14;
            return (0, _effects.all)([(0, _effects.race)({
              success: (0, _effects.take)(successActionType),
              failure: (0, _effects.take)(failureActionType)
            }), (0, _effects.put)(payload)]);

          case 14:
            response = _context.sent;
            _context.next = 20;
            break;

          case 17:
            _context.next = 19;
            return [(0, _effects.race)({
              success: (0, _effects.take)(successActionType),
              failure: (0, _effects.take)(failureActionType)
            }), (0, _effects.put)(payload)];

          case 19:
            response = _context.sent;

          case 20:
            _response = response;
            _response2 = (0, _slicedToArray3.default)(_response, 1);
            _response2$ = _response2[0];
            success = _response2$.success;
            failure = _response2$.failure;

            if (!success) {
              _context.next = 30;
              break;
            }

            _context.next = 28;
            return (0, _effects.call)(resolve, success.payload);

          case 28:
            _context.next = 32;
            break;

          case 30:
            _context.next = 32;
            return (0, _effects.call)(reject, new SubmissionError(failure.payload));

          case 32:
            _context.next = 0;
            break;

          case 34:
          case 'end':
            return _context.stop();
        }
      }
    }, formSubmitSaga, this);
  });
};